module.exports = __webpack_public_path__ + "img/6_KLINGER_EXPERT.64b5a678.jpg";